import Vue from 'vue';
// antd-vue
import AButton from 'ant-design-vue/lib/button';
import ADropdown from 'ant-design-vue/lib/dropdown';
import AIcon from 'ant-design-vue/lib/icon';
import AMenu from 'ant-design-vue/lib/menu';
import 'ant-design-vue/dist/antd.css'

import App from './App.vue';
import router from "./router";
import store from './store';
import Cookies from 'js-cookie';
import axios from 'axios';
import Videojs from 'video.js'

// import "animate.css"
// import 'animate.css/animate.min.css';
// import wow from 'wowjs'
// import "wowjs/css/libs/animate.css"// 巨坑... 此地方要引入两个css

import AOS from 'aos'
import 'aos/dist/aos.css'

import 'video.js/dist/video-js.css'

import { Icon, Tabbar, TabbarItem, Form, Field, Cell, Button, CountDown, Uploader, NoticeBar, Notify, Toast, Dialog } from 'vant';

Vue.use(Icon);
Vue.use(Tabbar);
Vue.use(TabbarItem);
Vue.use(Form);
Vue.use(Field);
Vue.use(Cell);
Vue.use(Button);
Vue.use(NoticeBar);
Vue.use(CountDown);
Vue.use(Uploader);

Vue.use(AButton);
Vue.use(ADropdown);
Vue.use(AIcon);
Vue.use(AMenu);



Vue.config.productionTip = false

Vue.use(Cookies);
Vue.prototype.$video = Videojs;
Vue.prototype.$axios = axios;
Vue.prototype.$Cookies = Cookies;
Vue.prototype.$Notify = Notify;
Vue.prototype.$Toast = Toast;
Vue.prototype.$Dialog = Dialog;
// Vue.prototype.$wow = wow;
Vue.prototype.$AOS = AOS;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
